module.exports = function getResource (label) {
    let resources = {
        addPromoCode: 'Add promo code',
        enterPromoRewards: 'Enter Promo & Rewards'
    };
    return resources[label];
};
